<template>
    <div class="content pg_product_qrcode">
        <div class="logo">
            <img :src="logo" alt="">
        </div>
        <div class="welcome-text">
            {{ $lang.get("momenta.hub.welcome_text") }}
        </div>
        <div class="select-country">
            {{ $lang.get("momenta.hub.select_country") }}:
        </div>
        <div class="country">
            <form method="post">
                <input type="hidden" name="_token" :value="csrf">
                <div>
                    <div class="my-select">
                        <v-select label="name" :options="sites" v-model="site" :searchable="false">
                            <template v-slot:option="option">
                                <img :src="option.icon_url" width="31" height="31" />
                                {{ option.name }}
                                <input :value="option.id" name="site_id" required type="hidden"/>
                            </template>
                        </v-select>
                        <img v-if="site" :src="site.icon_url" class="image-selected" />
                        <input :value="site.domain" name="domain" required type="hidden"/>
                    </div>
                </div>
                <div class="btn-access">
                    <button>
                        {{ $lang.get("momenta.hub.access") }} >
                    </button>
                </div>
            </form>
        </div>
        <div class="social">
            <a href="https://momentafarma.com" target="_blank">
                <img src="/images/icons/globe.png" />&nbsp;&nbsp;
                <span>momentafarma.com</span>
            </a>
            <a href="https://instagram.com/momentafarma" target="_blank">
                <img src="/images/icons/instagram.png" />&nbsp;&nbsp;
                <span>/momentafarma</span>
            </a>
            <a href="https://facebook.com/momentafarma" target="_blank">
                <img src="/images/icons/facebook.png" />&nbsp;&nbsp;
                <span>/momentafarma</span>
            </a>
        </div>

        <img :src="imgFooter" class="logo-footer"/>
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import VueCookies from 'vue-cookies'

export default {
    components: {
       vSelect 
    },
    props: ["sites","logo","imgFooter", "location"],
    data(){
        return {
            site: Lang.get("momenta.hub.select"),
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    created(){
        this.loadDefaultSite();
    },
    methods: {
        loadDefaultSite(){
            let defaultSite = VueCookies.get("default_site");
            if(!defaultSite){
                return this.getLocationFromUser();
            }

            this.sites.filter((site) => {
                if(site.domain == defaultSite){
                    this.site = site;
                }
            });
        },
        getLocationFromUser(){
            let codeCountry = this.location.countryCode.toLowerCase().trim();

            this.sites.filter((site) => {
                let parts = site.domain.split(".");

                if(parts[parts.length -1] == codeCountry){
                    this.site = site;
                }
            });
        },
    },
    watch: {
        site: {
            handler( val ){
                VueCookies.set('default_site' , val.domain);
            },
            deep: true
        }
    }
}
</script>
